import debounce from 'lodash/debounce';
import find from 'lodash/find';
import { Directive, ElementRef, OnInit, OnDestroy } from '@angular/core';

const rAF = requestAnimationFrame;
const SCROLL_THRESHOLD = 30;

@Directive({
  selector: '[keepScroll]',
  exportAs: 'keepScroll',
})
export class KeepScrollDirective implements OnInit, OnDestroy {
  private el;
  private listToObserve;
  private mutationObserver;
  private firstElm;

  constructor(el: ElementRef) {
    this.el = el.nativeElement;
  }

  public ngOnInit() {
    this.listToObserve = this.el.querySelector('.keep-scroll') || this.el;
    this._initSetScrollTop();
    this._initMutationObserver();
    this.startObserving();
  }

  public ngOnDestroy() {
    this.mutationObserver.disconnect();
    this.mutationObserver = null;
    this.listToObserve = null;
  }

  public startObserving() {
    this.mutationObserver.observe(this.listToObserve, { childList: true });
  }

  public stopObserving() {
    this.mutationObserver.disconnect();
    this.firstElm = null;
  }

  private _initSetScrollTop() {
    const setScrollTop = debounce(() => {
      const elmScrollTop = this.el.scrollTop - SCROLL_THRESHOLD;
      if (elmScrollTop <= SCROLL_THRESHOLD) {
        this.firstElm = this.listToObserve?.querySelector('.keep-scroll-item:first-of-type');
      } else this.firstElm = null;
    }, 100);
    this.el.addEventListener('scroll', setScrollTop);
  }

  private _initMutationObserver() {
    this.mutationObserver = new MutationObserver( mutations => {
      if (mutations.length === 1) {
        const mutation = mutations[0];
        const lastItem = (mutation.target as any).querySelector('.keep-scroll-item:last-child');
        if (find(mutation.addedNodes, lastItem)) return;
      }
      // rAF is used to remove forced browser reflow
      rAF(() => {
        const el = this.el;
        if (this.firstElm && el.scrollHeight > el.offsetHeight) {
          rAF(() =>
            el.scrollTop = this.firstElm.offsetTop - 80, // padding
          );
        }
      });
    });
  }

}
